import {
  Component, EventEmitter, Input, Output
} from '@angular/core';

export interface IDataInterface {
  type?: string,
  settings?: ISettingsInterface
}

export interface ISettingsInterface {
  heading?: string
  content?: string
  buttons?: Array<IButtonsInterface>
  image?: string
}

export interface IButtonsInterface {
  label?: string
  link?: string
}

@Component({
  selector: 'app-product-banner',
  templateUrl: './product-banner.component.html',
  styleUrls: ['./product-banner.component.scss']
})
export class ProductBannerComponent {
  @Input() data!: IDataInterface;
  @Output() startQuoteEvent = new EventEmitter<string>();

  onClick(url?: string) {
    window.open(url);
  }
}
